import DeleteOfficeContainer from "./DeleteOfficeContainer";
export default DeleteOfficeContainer;
